import {useEffect, useState} from 'react';
import {useBrowserWidth} from '~/common/hooks/useBrowserWidth';

export const useContentHeight = ({containerHeight, isWebview}) => {
  const browserWidth = useBrowserWidth();

  const [height, setHeight] = useState('100%');

  useEffect(() => {
    if (isWebview) {
      setHeight('100vh');
    } else if (browserWidth < 500) {
      setHeight('512px');
    } else if (containerHeight) {
      setHeight(containerHeight);
    }
  }, [browserWidth, containerHeight]);

  return height;
};
